<template>
  <div class="exr-child">
    <el-form-item label="选项">
      <div class="exr-child-items">
        <div class="exr-child-item" v-for="(item, key) in value.items" :key="key">
          <div class="form-item-flex-row">
            <el-input v-model="item.text" @paste.native.capture.prevent="handlePasteItems($event, key)"></el-input>
            <PinyinInput v-model="item.pinyin" v-if="config.pinyin" :text="item.text" :uppercase="false"></PinyinInput>
            <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
            <el-button icon="el-icon-plus" tabindex="-1" v-if="showAddItem" @click="addItem(key)"></el-button>
          </div>
          <PinyinPreview v-if="config.pinyin" :text="item.text" :pinyin="item.pinyin" popover></PinyinPreview>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="答案" class="exr-answer-line">
      <el-radio v-for="(item, key) in value.items" :key="key" :label="key" v-model="value.answer">{{key + 1}}.{{item.text}}</el-radio>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ChildItem',
  props:{
    config: {},
    value: Object,
    number: Number
  },
  components: {
    PinyinPreview: require('@/components/PinyinPreview').default,
    PinyinInput: require('@/components/PinyinInput').default,
  },
  data () {
    return {

    }
  },
  created () {
    this.normalizedModel()
  },
  watch: {
    value () {
      this.normalizedModel()
    }
  },
  computed: {
    showAddItem () {
      return this.config.maxItemsCount === 0 || this.config.maxItemsCount > this.value.items.length
    }
  },
  methods: {
    normalizedModel () {
      let count = Math.max(this.config.minItemsCount, 1)
      if (this.value.items.length < count) {
        this.value.items = this.value.items.concat(Array(Math.max(count - this.value.items.length, 1)).fill().map(() => {
          return {}
        }))
      }
    },
    getItems () {
      return this.value.items.filter(n => n.text)
    },
    addItem (index) {
      this.value.items.splice(index + 1, 0, {})
    },
    removeItem (index) {
      if (this.value.items.length > 1 && this.config.minItemsCount < this.value.items.length) {
        this.value.items.splice(index, 1)
      } else {
        this.value.items.splice(index, 1, {})
      }
    },
    handlePasteItems (event, index) {
      let text = event.clipboardData.getData('Text')
      if (/^\s*$/.test(text)) {
        return
      }
      text.split(/\r\n|\n/).forEach((n, i) => {
        let cells = n.split(/\t|\|/)
        this.setPasteText(index + i, 'text', cells[0], i === 0)
        if (this.config.pinyin && cells.length > 1) {
          this.setPasteText(index + i, 'pinyin', cells[1])
        }
      })
    },
    setPasteText(index, attr, text, append) {
      if (text !== null && !/^\s*$/.test(text) && this.value.items.length > index) {
        if (append) {
          document.execCommand('insertText', false, text)
        } else {
          this.$set(this.value.items[index], attr, text)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.exr-child-item{
  + .exr-child-item{
    margin-top: 8px;
  }
}
</style>